var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.125 0.875H0.875C0.5 0.875 0.25 1.125 0.25 1.5V13.375C0.25 13.75 0.5 14 0.875 14H17.125C17.5 14 17.75 13.75 17.75 13.375V1.5C17.75 1.125 17.5 0.875 17.125 0.875ZM10.25 12.125H7.75C7.375 12.125 7.125 11.875 7.125 11.5C7.125 11.125 7.375 10.875 7.75 10.875H10.25C10.625 10.875 10.875 11.125 10.875 11.5C10.875 11.875 10.625 12.125 10.25 12.125Z",
    fill: "#2877EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9376 15.4375C11.8126 15.3125 11.6876 15.25 11.5001 15.25H6.50009C6.31259 15.25 6.18759 15.3125 6.06259 15.4375L4.81259 16.6875C4.62509 16.875 4.56259 17.125 4.68759 17.375C4.75009 17.625 5.00009 17.75 5.25009 17.75H12.7501C13.0001 17.75 13.2501 17.625 13.3126 17.375C13.4376 17.125 13.3751 16.875 13.1876 16.6875L11.9376 15.4375Z",
    fill: "#2877EE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.c6d8e0912878381c8ad9235d56aa33ea.svg";
export { ForwardRef as ReactComponent };